import { render, staticRenderFns } from "./CreateReadAloud.vue?vue&type=template&id=12180b23&scoped=true&"
import script from "./CreateReadAloud.vue?vue&type=script&lang=js&"
export * from "./CreateReadAloud.vue?vue&type=script&lang=js&"
import style0 from "./CreateReadAloud.vue?vue&type=style&index=0&id=12180b23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12180b23",
  null
  
)

export default component.exports